import { label } from "./Attributes";

export default function Preview({ command }) {
    return (
        <span className="ms-3">
            <span className="me-2">{label}</span>
            <span className="me-2">xyz</span>
            <code className="me-2">
                {command.settings.x || 0}m, {command.settings.y || 0}m,{" "}
                {command.settings.z || 0}m
            </code>
            <span className="me-2">yaw</span>
            <code className="me-2">
                {command.settings.yaw !== undefined &&
                command.settings.yaw !== null &&
                command.settings.yaw !== ""
                    ? `${command.settings.yaw}°`
                    : "flyzone"}
            </code>
            {command.settings.take_picture && (
                <>
                    <span>wait</span>
                    <code className="mx-2">
                        {command.settings.take_picture_delay_before}s
                    </code>
                    <span>Take picture, wait</span>
                    <code className="mx-2">
                        {command.settings.take_picture_delay_after}s
                    </code>
                </>
            )}
        </span>
    );
}
